export const ROOT_SET_AUTH_USER = "ROOT_SET_AUT_USER";
export const ROOT_UNSET_AUTH_USER = "ROOT_UNSET_AUT_USER";
export const ROOT_SET_AUTH_LOADING = "ROOT_SET_AUTH_LOADING";
export const ROOT_SET_AUTH_UNLOADING = "ROOT_SET_AUTH_UNLOADING";